import './App.css';
import Quotes from './components/Quotes';

const App = () => {

  return (
    
    <div className="App">
      <Quotes />
    </div>

  );

  
}


export default App;
